import { render, staticRenderFns } from "./step5.vue?vue&type=template&id=3cda3098&scoped=true"
import script from "./step5.vue?vue&type=script&lang=js"
export * from "./step5.vue?vue&type=script&lang=js"
import style0 from "./step5.vue?vue&type=style&index=0&id=3cda3098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cda3098",
  null
  
)

export default component.exports